angular.module('festzelt-os.modules.wallets.templates', [
    'ui.router',
    'festzelt-os.components'
]);

// Routes
require('./routes');

// Components
require('./components/al-wallet-template-editor/component')

// Factories
require('./factories/template');

// Stores
require('./store/wallet-templates');

// Workflows
require('./workflows');



// WEBPACK FOOTER //
// ./src/app/modules/wallets/templates/module.js